import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'CreateSellpoint',
    data () {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status == 200) {
                    this.validate_user_name_error = false;
                    this.validate_user_name_message = "This sellpoint does not exist"; //for adding existing business
                }else{
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
            })
        },
        preset_xtra() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //GET CATEGORIES
                        this.getBusinessCategories();
                        this.getMarketCategories();
                        this.getSellpoints(this.user.user_id);
                        //CHECK IF GROUP IS SET
                        // if(localStorage.getItem("sp_#_sellpoint") != undefined){
                        //     this.group_isset = true;
                        // }
                        this.loading = false;
                    }else {
                    this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                       this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        preset() {
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;

                    self.getBusinessCategories();
                    self.getMarketCategories();
                    // this.getSellpoints(this.user.user_id);

                    // self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },

        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },
        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
            })
        },
        getMarketCategories() {
            service.getMarketCategories(this).then(function(data) {
                this.market_categories = data.body.data;
            })
        },
        getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function(data) {
                this.market_groups = data.body.data;
            })
        },
        getSellpoints(user){
            service.getBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    //filter and select only single business
                    let result = data.body.data;
                    let arr = [];
                    result.forEach(element => {
                        if(element.business_type == 1){
                            arr.push(element);
                        } 
                    });
                    this.sellpoints = arr;
                }
            }).catch((err) => {
                if(err) {
                   //log it
                   console.log(err)
                }
            })
        },

        ///if payment for market plans exist for this marktet
        //.purchase plan
        //.marke purchase order
        //.set up business
        //.notify payment
        //.reroute
        //////./

        //market business registration with basic free payment
        setUpNewAccountBusiness(){
            this.resetMessages();
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3, //gallery
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
               this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_boarding_message = "Sellpoint Creation Successful.";
                            
                            //notify server of Order-Delivered
                            // this.notifyPayments(16,this.payment_ref,this.business.business_user_name); //16--Subscription-Delivered

                            //move to sellpoint in account
                            navi.push('/account');
                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },
        
        setUpExistingAccount(){
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            
            let navi = this.$router; 
            service.addExistingBusiness(this, credentials).then(function(data) {
                if((data.body.status == 201) || (data.body.status == 200)) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    //notify server of Order-Delivered
                    //this.notifyPayments(16,this.payment_ref,this.user.user_business); //15--Subscription-Delivered

                    //move to sellpoint in account
                    navi.push('/account');
                }
            }).catch((err) => {
                if(err) {
                   // console.log(err)
                   this.deactivate_processing();
                }
            })
        },

        //./marlet business registration with basic free payment


        createSellpoint(){
            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_market_category: this.business.market_category || 0,
                business_owner: this.user.user_id,
              //  business_group: localStorage.getItem("sp_#_sellpoint") || "nill",
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                toastr.error('This Username already exists', 'Warning!');
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    if(this.business.agree) {
                        service.addBusiness(this, credentials).then(function(data) {
                            if(data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');
                                //log user in
                                this.business = data.body.data;
                                navi.push('/'+this.business.business_user_name);
                                //this.setComponent('add-product','');
                            }
                        }).catch((err) => {
                            if(err) {
                                toastr.warning("Something went wrong", 'Warning!'); 
                                this.disable_btn = false;
                            }
                        })
                    }else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                }else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },

        addSelectedExistingSellpoint(){
            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill",
            }
            let navi = this.$router;
            if(credentials.business_user_name != undefined) {
                   service.addExistingBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');
                                //log user in
                               // this.business = data.body.data;
                                navi.push('/'+localStorage.getItem("sp_#_sellpoint"));
                                //this.setComponent('add-product','');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.warning("Something went wrong", 'Warning!'); 
                            this.disable_btn = false;
                        }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
            
        },

        addExistingSellpoint(){
            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill",
            }
            let navi = this.$router;
            if(!this.validate_user_name_error){
                toastr.error('This Sellpoint does not exist', 'Warning!');
            }else{
                if(credentials.business_user_name != undefined) {
                   service.addExistingBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');
                                //log user in
                               // this.business = data.body.data;
                                navi.push('/'+localStorage.getItem("sp_#_sellpoint"));
                                //this.setComponent('add-product','');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.warning("Something went wrong", 'Warning!'); 
                            this.disable_btn = false;
                        }
                })
               }else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },

        addNewSellpoint(){
            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill",
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                toastr.error('This Username already exists', 'Warning!');
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    if(this.business.agree) {
                        service.addNewBusiness(this, credentials).then(function(data) {
                            if(data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');
                                //log user in
                               // this.business = data.body.data;
                                navi.push('/'+localStorage.getItem("sp_#_sellpoint"));
                                //this.setComponent('add-product','');
                            }
                        }).catch((err) => {
                            if(err) {
                                toastr.warning("Something went wrong", 'Warning!'); 
                                this.disable_btn = false;
                            }
                        })
                    }else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                }else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },

},
created: function(){
    this.preset();
    if(this.$route.query.create == "new"){
        this.add_sellpoint = true;
    }
    if(this.$route.query.create == "add"){
        this.add_sellpoint = true;
        this.add_business = true;
    }
    // this.getBusinessCategories();
    this.getBusinessMarketGroups();
}
}



// WEBPACK FOOTER //
// ./src/pages/CreateSellpoint/script.js